/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum GrafanaReportType {
    Undefined = 0,
    Audio = 1,
    Devices = 2,
    HTTPAndConnections = 3,
    WindowsServers = 4,
    BlackBox = 5,
}
